<div class="container_table">
  <div class="area_table" [ngStyle]="tableAreaStyle">
    <mat-table  class="sticky table-mh centered-header centered-content"
      matSortDisableClear matSortDirection="desc" matSort #table
      [matSortActive]="matSortActive"
      [ngStyle]="tableContentStyle"
      [dataSource]="dataSource"
      [matSortActive]="matSortActive" >

      <ng-container *ngFor="let key of headerTable" [matColumnDef]="key">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <div [ngSwitch]="key">
            {{'inter-chain.executive.table.'+(key==='factor' ? factor : key) | translate:translateData }}
          </div>
        </mat-header-cell>

        <mat-cell *matCellDef="let element" [ngClass]="{'fixed-cell' : key==='customer'}">
          <div [ngSwitch]="key">
            <ng-template [ngSwitchCase]="(['variation','annual_variation'].includes(key) ? key : false )">
              <div class="variation-content">
                <span class="variation"
                  [ngbTooltip]="+element[key] ? ((+element[key] > 0 ? 'commons.arrow_variation.positive' : 'commons.arrow_variation.negative') | translate) : null"
                  container="body">
                  {{element[key] | formatBy:(selected === 'nps' ? 'nps' : 'percent')}}
                </span>
                <widget-utils-arrow-variation
                  [number]="element[key]"
                  [tooltip]="+element[key] ? ((+element[key] > 0 ? 'commons.arrow_variation.positive' : 'commons.arrow_variation.negative') | translate) : null">
                </widget-utils-arrow-variation>
              </div>
            </ng-template>

            <ng-template [ngSwitchCase]="(['properties_quantity'].includes(key) ? key : false )">
              {{element[key]}}
            </ng-template>

            <ng-template ngSwitchDefault>
              {{['factor'].includes(key) ? element[key]: selected === 'iro' ? (element[key] | formatBy: 'percent') : (element[key] | formatBy:formatNumber) }}
            </ng-template>
          </div>
        </mat-cell>


        <ng-container *ngIf="showTotals">
          <mat-footer-cell [ngClass]="{'fixed-cell' : key==='customer'}" *matFooterCellDef>
            <div class="tw-w-full tw-text-center" [ngSwitch]="key">
              <ng-template [ngSwitchCase]="['factor'].includes(key) ? key : false">
                <div class="tw-text-left">
                  <b>{{'commons.total' | translate }}</b>
                </div>
              </ng-template>

              <ng-template [ngSwitchCase]="'tripAdvisorRanking'">
                -
              </ng-template>

              <ng-template [ngSwitchCase]="(['properties_quantity'].includes(key) ? key : false )">
                {{totals[key]}}
              </ng-template>

              <ng-template [ngSwitchCase]="(['variation','annual_variation'].includes(key) ? key : false )">
                <div class="variation-content">
                  <span class="variation"
                    [ngbTooltip]="+totals[key] ? ((+totals[key] > 0 ? 'commons.arrow_variation.positive' : 'commons.arrow_variation.negative') | translate) : null"
                    container="body">
                    {{totals[key] | formatBy:(selected === 'nps' ? 'nps' : 'percent')}}
                  </span>
                  <widget-utils-arrow-variation
                    [number]="totals[key]"
                    [tooltip]="+totals[key] ? ((+totals[key] > 0 ? 'commons.arrow_variation.positive' : 'commons.arrow_variation.negative') | translate) : null">
                  </widget-utils-arrow-variation>
                </div>
              </ng-template>

              <ng-template ngSwitchDefault>
                {{selected === 'iro' ? (totals[key] | formatBy: 'percent'): totals[key] | formatBy:formatNumber}}
              </ng-template>
            </div>
          </mat-footer-cell>
        </ng-container>

      </ng-container>



      <mat-header-row *matHeaderRowDef="headerTable"></mat-header-row>
      <mat-row *matRowDef="let row; columns: headerTable;"></mat-row>
      <ng-container *ngIf="showTotals">
        <mat-footer-row *matFooterRowDef="headerTable"></mat-footer-row>
      </ng-container>
    </mat-table>

  </div>
</div>
